<template>
    <div :style="bgColor ? `background-color: ${bgColor}` : ''">
        <Container >
            <div :style="paddingStyle"></div>
        </Container>
    </div>
    
</template>

<script>
import Container from '../../../Layouts/Container.vue'

export default {
    components: {
        Container,
    },
    props: {
        padding: {
            type: Number,
            default: 10,
        },
        mobilePadding: {
            type: Number,
            default: 10,
        },
        bgColor: {
            type: String,
            default: null 
        },
    },
    data() {
        return {
            isMobile: false,
        };
    },
    computed: {
        paddingStyle() {
            return {
                paddingTop: (this.isMobile ? `${this.mobilePadding}px` : `${this.padding}px`)
            };
        },
    },
    mounted() {
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    methods: {
        checkIfMobile() {
            this.isMobile = window.matchMedia('(max-width: 768px)').matches;
        },
    },
};
</script>
